const queryOptions = (t) => [
  {
    name: 'name',
    displayName: t('queryBuilder.queryParam.queryOptions.group.name'),
    type: 'groupName',
    used: false,
    value: ''
  },
  {
    name: 'createdAt',
    displayName: t('queryBuilder.queryParam.queryOptions.group.createdAt'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'isActive',
    displayName: t('queryBuilder.queryParam.queryOptions.group.isActive'),
    type: 'select',
    values: [true, false],
    displayedValues: [
      t('queryBuilder.queryParam.queryOptions.group.isActiveValues.true'),
      t('queryBuilder.queryParam.queryOptions.group.isActiveValues.false')
    ],
    used: false,
    value: ''
  },
  {
    name: 'sort',
    displayName: t('queryBuilder.queryParam.queryOptions.group.sort.title'),
    type: 'key-value',
    keys: [
      { name: 'name', displayName: t('queryBuilder.queryParam.queryOptions.group.sort.keys.name') },
      { name: 'createdAt', displayName: t('queryBuilder.queryParam.queryOptions.group.sort.keys.createdAt') }
    ],
    values: [
      { name: 'asc', displayName: t('queryBuilder.queryParam.queryOptions.group.sort.values.asc') },
      { name: 'desc', displayName: t('queryBuilder.queryParam.queryOptions.group.sort.values.desc') }
    ],
    used: false,
    value: ''
  },
  {
    name: 'pagination',
    displayName: '',
    type: 'pagination',
    used: true,
    value: ''
  }
];

export default queryOptions;
